import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=1437c33d"
import script from "./AddGoods.vue?vue&type=script&lang=js"
export * from "./AddGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports